import dayjs from 'dayjs';

const TimeStamp: React.FC = () => {
  return <div className='message-timestamp'>{dayjs().format('HH:MM')}</div>;
};

export default TimeStamp;
